import React from 'react';
import { CFooter } from '@coreui/react';
import moment from 'moment';
import versionFile from '../assets/version.json';

const AppFooter = () => {
  const year = moment().format('YYYY');

  return (
    <CFooter className="mt-4">
      <div style={{ textAlign: 'center', width: '100%' }}>
        newscube v{versionFile.version}
        <span className="ms-1">&copy; {year} adorum publishing GmbH</span>
        {' - '}
        <a href="/datenschutz" target="_blank" style={{ color: 'rgba(44, 56, 74, 0.95)' }}>
          Datenschutzerkl&auml;rung
        </a>
      </div>
    </CFooter>
  );
};

export default React.memo(AppFooter);
